// extracted by mini-css-extract-plugin
export default {"graphFactPanelEntry":"oTFHRI9","collapsibleItemLvl2":"aCEnor8"};